import { StatCategoryConfig, StatCategoryConfigMap, StateCategory } from "../../types";
import { BookingStatsAggregator } from "../booking-stats-aggregator";
import { LoungeRequestStatsAggregator } from "../lounge-stats-aggregator";
import { SessionStatsAggregator } from "../session-stats-aggregator";
import { UserStatsAggregator } from "../user-stats-aggregator";
import { SlotStatsAggregator } from "../slot-stats-aggregator";

export class StatsCategoryRegistry {
  private static readonly CATEGORY_CONFIGS: { [K in StateCategory]: StatCategoryConfigMap[K] } = {
    USERS: {
      types: ["TOTAL_LEARNERS", "TOTAL_COACHES", "TOTAL_USERS", "TOTAL_DUAL_ROLE", "LAST_MONTH_USERS"],
      expiryHours: 1,
      aggregator: new UserStatsAggregator(),
    },
    BOOKINGS: {
      types: ["TOTAL_BOOKINGS", "LAST_MONTH_BOOKINGS"],
      expiryHours: 1,
      aggregator: new BookingStatsAggregator(),
    },
    SESSIONS: {
      types: [
        "TOTAL_SESSIONS",
        "LAST_MONTH_SESSIONS",
        "COMPLETED_SESSIONS",
        "COMPLETED_BOOKED_SESSIONS",
        "COMPLETED_DIRECT_SESSIONS",
        "COMPLETED_LOUNGE_SESSIONS",
        "MISSED_BOOKED_SESSIONS",
        "MISSED_DIRECT_SESSIONS",
      ],
      expiryHours: 0.5,
      aggregator: new SessionStatsAggregator(),
    },
    LOUNGE: {
      types: ["TOTAL_LOUNGE_REQUESTS", "LAST_MONTH_LOUNGE_REQUESTS"],
      expiryHours: 1,
      aggregator: new LoungeRequestStatsAggregator(),
    },
    SLOTS: {
      types: ["TOTAL_SLOTS", "LAST_MONTH_SLOTS", "AVAILABLE_SLOTS", "BOOKED_SLOTS"],
      expiryHours: 1,
      aggregator: new SlotStatsAggregator(),
    },
  };

  static getConfig(category: StateCategory): StatCategoryConfig | undefined {
    return this.CATEGORY_CONFIGS[category];
  }

  static getAllCategories(): StateCategory[] {
    return Object.keys(this.CATEGORY_CONFIGS) as StateCategory[];
  }

  static getCategoryUpdateInfo(category: StateCategory) {
    return this.CATEGORY_CONFIGS[category].expiryHours;
  }
}
